module.exports = __webpack_public_path__ + "static/img/suisui2.ec2d6e7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/suisui2.svg
// module id = tQq3
// module chunks = 0